import React from "react";
import PageLoader from "../../../components/pageLoader";
import Carousel from "./components/carousel/carousel";
import { NavLink } from "react-router-dom";
import useCarousel from "../../../hooks/public/useCarousel";

const CarouselSlider = () => {
  const { data, isLoading } = useCarousel();
  return (
    <section className="carousel-slider-section">
      {isLoading && <PageLoader />}
      {data && <Carousel data={data} />}
      <div className="carousel-update-btn-container">
        <NavLink className="update-btn" to="/admin/home/carousel">
          Update Carousel
          <i className="fa fa-upload ml-2"></i>
        </NavLink>
      </div>
    </section>
  );
};

export default CarouselSlider;
